/* 🤖 this file was generated by svg-to-ts */
export const matIconDensityLarge: {
  name: 'density-large';
  data: string;
} = {
  name: 'density-large',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 3h18v2H3zm0 16h18v2H3z"/></svg>`
};
